<template>
    <div class="overflow-hidden border border-gray-300 rounded-md">
        <div class="flex items-center bg-gray-100">
            <div class="w-10"></div>
            <div class="col col-md-3 d-md-block py-2 font-bold">Название</div>
            <div class="col d-md-block d-none py-2 font-bold">Позиция показа</div>
            <div class="col d-md-block py-2 font-bold">Активен</div>
        </div>
        <Draggable v-model="list" tag="div">
            <div
                v-for="item in list"
                :key="item.id"
                class="flex items-center h-10 px-2 py-4 border-t border-gray-300"
            >
                <div class="w-10">
                    <CIcon
                        :height="16"
                        :content="cilCursorMove"
                        class="handle" />
                </div>
                <div class="col col-md-3 d-md-block">
                    <span
                        class="text-purple-700 cursor-pointer hover:underline"
                        :title="item.route_name"
                        @click="$emit('select', item.id)"
                    >{{ item.title }}
                    </span>
                </div>
                <div class="col d-md-block d-none truncate">
                    {{ item.position }}
                </div>
                <div class="col d-md-block">
                    <CBadge :color="item.enabled ? 'success' : 'secondary'">
                        {{ item.enabled ? "Да" : "Нет" }}
                    </CBadge>
                </div>
            </div>
        </Draggable>
    </div>
</template>

<script>
    import Draggable from 'vuedraggable';
    import { cilCursorMove } from '@coreui/icons';

    export default {
        components: {
            Draggable
        },

        props: {
            data: {
                type: Array,
                default: () => [],
            },
        },

        data: () => ({
            cilCursorMove,
        }),

        computed: {
            list: {
                get() {
                    return this.data;
                },

                set(v) {
                    const updated = v.map((item, idx) => {
                        item.position = idx + 1
                        return item
                    })

                    this.$emit('update:data', updated)
                }
            },
        },

        async mounted() {
        },

        methods: {},
    };
</script>
